import { MantineThemeOverride } from '@mantine/core';

export type AffixTheme = NonNullable<MantineThemeOverride['components']>['Affix'];

export const Affix: AffixTheme = {
  // todo: define
};
